export default "__VITE_ASSET__1NQJTFVM__"